module.exports = __webpack_public_path__ + "static/media/logo.b482a1e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 272
// module chunks = 2